/**
 * Cache clearing utility to prevent white screen issues from stale caches
 * This runs in the browser environment only, not during build
 */

const CACHE_VERSION = 'v1';

/**
 * Clear service workers if any exist
 */
const clearServiceWorkers = async () => {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
    return;
  }

  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    for (let registration of registrations) {
      const success = await registration.unregister();
      if (success) {
        console.log('Service worker unregistered successfully');
      }
    }
  } catch (error) {
    console.error('Error unregistering service workers:', error);
  }
};

/**
 * Clear all caches periodically to prevent stale content
 */
const clearStaleCaches = async () => {
  if (typeof window === 'undefined' || typeof localStorage === 'undefined' || !('caches' in window)) {
    return;
  }

  try {
    const currentVersion = localStorage.getItem('cacheVersion');
    
    // If version changed or not set, clear all caches
    if (currentVersion !== CACHE_VERSION) {
      const names = await caches.keys();
      await Promise.all(
        names.map(name => {
          console.log('Deleting cache:', name);
          return caches.delete(name);
        })
      );
      
      localStorage.setItem('cacheVersion', CACHE_VERSION);
      console.log('All caches cleared successfully');
    }
  } catch (error) {
    console.error('Error clearing caches:', error);
  }
};

/**
 * Initialize cache clearing on app load
 */
const initCacheCleaning = () => {
  // Only run in browser environment
  if (typeof window === 'undefined') {
    return;
  }

  // Clear service workers
  clearServiceWorkers();
  
  // Clear stale caches
  clearStaleCaches();
};

export default initCacheCleaning;

